// extracted by mini-css-extract-plugin
export default {"postfix":"_3_lRy"};